module.exports = __webpack_public_path__ + "assets/img/hz1.8d240836.png";